import { render, staticRenderFns } from "./AdminNoticeList.vue?vue&type=template&id=49c2ffdd&scoped=true&lang=pug&"
import script from "./AdminNoticeList.vue?vue&type=script&lang=ts&"
export * from "./AdminNoticeList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c2ffdd",
  null
  
)

export default component.exports